import { doPostRequest } from "../../shared/api/base-api";
import { apiUrl } from "../../shared/constants";


//Generate New Test api
export function submitNewsletter(data) {
  return doPostRequest(apiUrl.subscribeUser, data);
}